var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAfishaDailyWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 81 29"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.784
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.414 21.057 35.18 9.158 23.28 21.057l8.78-4.566M48.672 9.158 36.773 21.057M56.43 9.158 44.53 21.057l8.011-1.56M46.39 27.169 79.994 10.12M69.91 9.158 57.829 21.241M12.137 5.985 1 21.628s27.623-5.362 27.623-15.95C28.623 2.29 25.483 1 20.9 1c-9.487 0-18.386 6.237-18.386 6.237"
}))));
export default SvgIconAfishaDailyWhite;